import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';


const Body = ({ generalReport , beginDate , endDate }) => (
    <div>
    {
        generalReport.length <= 0 ? 
        //If there's NO DATA to display
        <NoDataMsg/>
        : 
        //If there's DATA
        <div className="clearfix">
            <div className="row m-0">
                <div className="text-center list_header">
                    {beginDate ? 
                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                { endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b>: moment().format('MMMM Do, YYYY')}</p>
                    : ""}
                </div>
            </div>
            <div className = "border border-primary">
                <div className = "col-lg-12  clearfix mt-1 text-center grey-text size_1-3vmax  mb-1" >
                    <div className = "row">
                        <div className = "col-lg-2  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Beginning Inventory
                                    </p>
                                    <p className='green-text'>
                                        {getDollarFormat(generalReport.openingValue)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>+</p>
                                </div>
                            </div>   
                        </div>

                        <div className = "col-lg-2  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Puchase Order Value
                                    </p>
                                    <p className='green-text'>
                                        {getDollarFormat(generalReport.purchasevalue)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>+</p>
                                </div>
                            </div>   
                        </div>

                        <div className = "col-lg-2  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Transfered In Value
                                    </p>
                                    <p className='green-text'>
                                        {getDollarFormat(generalReport.transferedIn)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>+</p>
                                </div>
                            </div>   
                        </div>

                        <div className = "col-lg-2  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Other Additions Value
                                    </p>
                                    <p className='red-text'>
                                        {getDollarFormat(generalReport.otherAdditionsValue)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>-</p>
                                </div>
                            </div>   
                        </div>

                        <div className = "col-lg-2  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Transfered Out Value
                                    </p>
                                    <p className='red-text'>
                                        {getDollarFormat(generalReport.transferedOut)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>-</p>
                                </div>
                            </div>   
                        </div>
                        <div className = "col-lg-2  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Destroyed Value
                                    </p>
                                    <p className='red-text'>
                                        {getDollarFormat(generalReport.destroyedValue)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>-</p>
                                </div>
                            </div>   
                        </div>
                        <div className = "col-lg-3  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Lost/Theft Value
                                    </p>
                                    <p className='red-text'>
                                        {getDollarFormat(generalReport.lostTheftValue)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>-</p>
                                </div>
                            </div>   
                        </div>
                        <div className = "col-lg-3  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Return to Distributor Value
                                    </p>
                                    <p className='red-text'>
                                        {getDollarFormat(generalReport.returnToDistributorValue)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>-</p>
                                </div>
                            </div>   
                        </div>

                        <div className = "col-lg-2  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Other Deductions Value
                                    </p>
                                    <p className='red-text'>
                                        {getDollarFormat(generalReport.otherDeductionsValue)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>-</p>
                                </div>
                            </div>   
                        </div>
                        <div className = "col-lg-2  mt-1">
                            <div className="row">
                                <div className = "col-lg-10">
                                    <p className='purpleText'>
                                        Closing Inventory Value
                                    </p>
                                    <p className='green-text'>
                                        {getDollarFormat(generalReport.closingValue)}
                                    </p>
                                </div>
                                <div className = "col-lg-1">
                                    <p>=</p>
                                </div>
                            </div>   
                        </div>

                        <div className = "col-lg-2  mt-1 green-text">
                            <div className="row">
                                <div className = "col-lg-12">
                                    <p className='purpleText'>
                                        COGS
                                    </p>
                                    <p>
                                        {getDollarFormat(generalReport.cogs)}
                                    </p>
                                </div>
                                
                            </div>   
                        </div>

                        

                    </div>
                </div>
            </div>
            <div className = "col-lg-12  clearfix mt-1">
                <table className="table table-striped table-hover ">
                        <thead>
                            <tr>
                                <th className='tableHeaderColorGray'>
                                    Information
                                </th>
                                <th className='tableHeaderColorGray'>
                                    Detail
                                </th>
                            </tr>
                        </thead>
                        <tbody className='purpleText'>
                                <tr>
                                    <td><strong>Gross Sales</strong></td>
                                    <td>{getDollarFormat(generalReport.totalAmout)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Net Sales</strong></td>
                                    <td>{getDollarFormat(generalReport.netSales)}</td>
                                </tr>
                                <tr>
                                <td><strong>Total Tax</strong></td>
                                    <td>{getDollarFormat(generalReport.totalTax)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Total Discount</strong></td>
                                    <td>{getDollarFormat(generalReport.totalDiscountAmount)}</td>
                                </tr>
                                <tr>
                                <td><strong>Opening Inventory Value</strong></td>
                                    <td>{getDollarFormat(generalReport.openingValue)}</td>
                                </tr>
                                <tr>
                                <td><strong>Purchases</strong></td>
                                    <td>{getDollarFormat(generalReport.purchasevalue)}</td>
                                </tr>
                                <tr>
                                <td><strong>Transfered In</strong></td>
                                    <td>{getDollarFormat(generalReport.transferedIn)}</td>
                                </tr>
                                <tr>
                                <td><strong>Other Additions</strong></td>
                                    <td>{getDollarFormat(generalReport.otherAdditionsValue)}</td>
                                </tr>
                                <tr>
                                <td><strong>Transfered Out</strong></td>
                                    <td>{getDollarFormat(generalReport.transferedOut)}</td>
                                </tr>
                                <tr>
                                <td><strong>Destroyed</strong></td>
                                    <td>{getDollarFormat(generalReport.destroyedValue)}</td>
                                </tr>
                                <tr>
                                <td><strong>Lost/Theft</strong></td>
                                    <td>{getDollarFormat(generalReport.lostTheftValue)}</td>
                                </tr>
                                <tr>
                                <td><strong>Return to Distributor</strong></td>
                                    <td>{getDollarFormat(generalReport.returnToDistributorValue)}</td>
                                </tr>
                                <tr>
                                <td><strong>Other Deductions</strong></td>
                                    <td>{getDollarFormat(generalReport.otherDeductionsValue)}</td>
                                </tr>
                                <tr>
                                <td><strong>Closing Inventory</strong></td>
                                    <td>{getDollarFormat(generalReport.closingValue)}</td>
                                </tr>
                                <tr>
                                <td><strong>Cost Of Goods Sold</strong></td>
                                    <td>{getDollarFormat(generalReport.cogs)}</td>
                                </tr> 
                        </tbody>
                </table>
            </div>
            

            </div>    
            
        }
    </div>
);
export default Body;